import TextInputField from "components/common/Auth/TextInputField";
import SubmitButton from "components/common/Auth/SubmitButton";
import React from "react";
import { useForget } from "@/modules/Auth/hooks/useForget";
import { translate } from "components/common/Translate/Translate";
import { translateFunc } from "@/utils/translateFunc";
import useRecaptcha from "components/modules/Auth/ReCaptcha/useRecaptcha";
import ReCaptchaComponent from "@/components/modules/Auth/ReCaptcha/ReCaptchaComponent";

const ForgetPasswordForm = () => {
    const { register, handleSubmit, onSubmit, errors, pending, isReqSuccess, usedEmail, resetMutation } = useForget();
    const { executeRecaptcha, recaptchaRef } = useRecaptcha();

    const handleFormSubmit = async (data: any) =>
        executeRecaptcha({
            data,
            onSuccess: onSubmit,
            onError: () => {
                resetMutation();
            },
        });

    return (
        <>
            {!isReqSuccess && (
                <>
                    <h2 className="text-2xl font-bold text-center text-gray-700 dark:text-white">
                        {translate("form-title")}
                    </h2>
                    <form className="space-y-4" onSubmit={handleSubmit(handleFormSubmit)} autoComplete="off">
                        <p className="text-center text-sm">{translate("form-subtitle")}</p>
                        {/* Email Field */}
                        <TextInputField
                            {...register("email")}
                            type="text"
                            title={translate("email-field-title")}
                            placeholder={translate("email-field-title")}
                            errorMsg={errors.email?.message}
                            preventWhiteSpace={true}
                        />
                        <ReCaptchaComponent recaptchaRef={recaptchaRef} />
                        {/* Submit button */}
                        <SubmitButton pending={pending} title={translate("submit-button-title")} />
                    </form>
                </>
            )}

            {isReqSuccess && (
                <>
                    <h2 className="text-2xl font-bold text-center text-gray-700 dark:text-white mb-4">
                        {translate("request-sent-form-title")}
                    </h2>
                    <p className="text-center">{translateFunc("request-sent-subtitle", { email: usedEmail })}</p>
                </>
            )}
        </>
    );
};

export default ForgetPasswordForm;
